import React from "react";
import { Routes, Route, Navigate } from "react-router";
import AuthFooter from "../components/Footers/AuthFooter";

type AuthViewProps = {
  mainContentRef: React.RefObject<HTMLDivElement | null>;
  routeElements: React.ReactNode;
  redirectToWildcard?: boolean;
};

const AuthView = ({ mainContentRef, routeElements, redirectToWildcard }: AuthViewProps) => {
  return (
    <>
      <div className="main-content" ref={mainContentRef}>
        <Routes>
          {routeElements}
          {redirectToWildcard && <Route path="/*" element={<Navigate to="/admin/dashboard" />} />}
        </Routes>
      </div>
      <AuthFooter />
    </>
  );
};

export default AuthView;
